import use_express_dropoff_endpoint from './use_express_dropoff_endpoint/use_express_dropoff_endpoint';
import use_express_route_session_endpoint from './use_express_route_session_endpoint/use_express_route_session_endpoint';
import use_express_pickup_endpoint from './use_express_pickup_endpoint/use_express_pickup_endpoint';
import use_express_lab_endpoint from './use_express_lab_endpoint/use_express_lab_endpoint';
import date_range_preset_configs from './date_range_preset_configs/date_range_preset_configs';
import can_access_sensitive_info_dialog from './can_access_sensitive_info_dialog/can_access_sensitive_info_dialog';
import hauling_permissions from './hauling_permissions/hauling_permissions';
import can_use_new_splits from './can_use_new_splits/can_use_new_splits';
import can_demo_geofence_tool from './can_demo_geofence_tool/can_demo_geofence_tool';
import can_access_pooling from './can_access_pooling/can_access_pooling';
import can_access_stocks from './can_access_stocks/can_access_stocks';
import use_two_level_banking_approval from './use_two_level_banking_approval/use_two_level_banking_approval';
import use_new_lab_form from './use_new_lab_form/use_new_lab_form';
import can_manage_mobile_app_processor_workflow from './can_manage_mobile_app_processor_workflow/can_manage_mobile_app_processor_workflow';
import use_new_hauler_company_form from './use_new_hauler_company_form/use_new_hauler_company_form';
import use_legacy_processor_form from './use_legacy_processor_form/use_legacy_processor_form';
import can_use_weekly_pay_frequency from './can_use_weekly_pay_frequency/can_use_weekly_pay_frequency';
import can_access_cdi_quality_report_producer from './can_access_cdi_quality_report_producer/can_access_cdi_quality_report_producer';
import can_access_adhoc_reports from './can_access_adhoc_reports/can_access_adhoc_reports';
import can_create_stock_holder from './can_create_stock_holder/can_create_stock_holder';
import can_opt_out_mailed_pay_statements from './can_opt_out_mailed_pay_statements/can_opt_out_mailed_pay_statements';
import can_access_schedule_automatch from './can_access_schedule_automatch/can_access_schedule_automatch';
import can_access_schedule_automatch_demo_mode from './can_access_schedule_automatch/can_access_schedule_automatch_demo_mode';
import enable_autopilot_distance_modality from './can_access_schedule_automatch/enable_autopilot_distance_modality';
import enable_autopilot_cost_modality from './can_access_schedule_automatch/enable_autopilot_cost_modality';
import can_access_schedule_automatch_dev_tools from './can_access_schedule_automatch/can_access_schedule_automatch_dev_tools';
import enable_producer_profile from './enable_producer_profile/enable_producer_profile';
import enable_processor_profile from './enable_processor_profile/enable_processor_profile';
import enable_hauler_profile from './enable_hauler_profile/enable_hauler_profile';
import can_use_new_route_session_table from './can_use_new_route_session_table/can_use_new_route_session_table';
import can_use_bay_scheduling from './can_use_bay_scheduling/can_use_bay_scheduling';
import can_access_receiving_pump_off from './can_access_receiving_pump_off/can_access_receiving_pump_off';
import can_access_supply_generator from './can_access_supply_generator/can_access_supply_generator';
import can_access_processed_fluids_receiving from './can_access_processed_fluids_receiving/can_access_processed_fluids_receiving';
import can_access_processed_fluids_configurable_rapid_test from './can_access_processed_fluids_receiving/can_access_processed_fluids_configurable_rapid_test';
import use_express_migration_endpoints from './use_express_migration_endpoints/use_express_migration_endpoints';
import use_express_auth_endpoints from './use_express_auth_endpoints/use_express_auth_endpoints';

const mockedSplits = [
    use_express_pickup_endpoint,
    use_express_dropoff_endpoint,
    use_express_route_session_endpoint,
    use_express_lab_endpoint,
    date_range_preset_configs,
    can_access_sensitive_info_dialog,
    hauling_permissions,
    can_use_new_splits,
    can_demo_geofence_tool,
    can_opt_out_mailed_pay_statements,
    can_access_pooling,
    can_access_stocks,
    use_two_level_banking_approval,
    use_new_lab_form,
    can_manage_mobile_app_processor_workflow,
    use_new_hauler_company_form,
    use_legacy_processor_form,
    can_use_weekly_pay_frequency,
    can_access_cdi_quality_report_producer,
    can_access_adhoc_reports,
    can_create_stock_holder,
    can_access_schedule_automatch,
    can_access_schedule_automatch_demo_mode,
    enable_autopilot_distance_modality,
    enable_autopilot_cost_modality,
    can_access_schedule_automatch_dev_tools,
    enable_producer_profile,
    enable_processor_profile,
    enable_hauler_profile,
    can_use_new_route_session_table,
    can_use_bay_scheduling,
    can_access_receiving_pump_off,
    can_access_supply_generator,
    can_access_processed_fluids_receiving,
    can_access_processed_fluids_configurable_rapid_test,
    use_express_migration_endpoints,
    use_express_auth_endpoints,
    // This comment forces multi line array to help mitigate git conflicts
];
export default mockedSplits;
